import React, { useMemo } from 'react';
import { Image, StyleSheet } from 'react-native';
import Animated, { interpolate, useAnimatedStyle, useDerivedValue, useSharedValue, } from 'react-native-reanimated';
import { Button, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import Logo from 'design-system/Logo';
import { useStatusBarHeight, usePureHeaderHeight } from 'hooks/useHeaderHeight';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../../constants';
const Header = ({ logoUrl, title, subtitle, discountedOffers, scrollY, onPress, buttonText, children }) => {
    const pureHeaderHeight = usePureHeaderHeight();
    const statusBarHeight = useStatusBarHeight();
    const logoStartsToDisappearAt = useSharedValue(statusBarHeight);
    const logoTop = useSharedValue(statusBarHeight + pureHeaderHeight);
    const titleOffset = useSharedValue(rem(72 + 16));
    const titleTop = useDerivedValue(() => logoTop.value + titleOffset.value);
    const discountedOfferTop = useDerivedValue(() => titleTop.value + titleOffset.value * 0.6);
    const logoStyle = useAnimatedStyle(() => ({
        top: logoTop.value,
        transform: [
            {
                translateY: -scrollY.value,
            },
        ],
        opacity: interpolate(logoTop.value - scrollY.value, [0, logoStartsToDisappearAt.value], [0, 1], 'clamp'),
    }));
    const titleStyle = useAnimatedStyle(() => ({
        top: titleTop.value,
        transform: [
            {
                translateY: -scrollY.value,
            },
        ],
        opacity: interpolate(titleTop.value - scrollY.value, [0, logoStartsToDisappearAt.value], [0, 1], 'clamp'),
    }));
    const discountedOfferStyle = useAnimatedStyle(() => ({
        top: discountedOfferTop.value,
        transform: [
            {
                translateY: -scrollY.value,
            },
        ],
        opacity: interpolate(titleTop.value - scrollY.value, [0, logoStartsToDisappearAt.value], [0, 1], 'clamp'),
    }));
    const msmStyle = useAnimatedStyle(() => ({
        top: logoTop.value,
        opacity: interpolate(logoTop.value - scrollY.value, [0, logoStartsToDisappearAt.value], [0, 1], 'clamp'),
    }));
    const { paddingHorizontal } = useAppFrameDimensions(isWeb);
    const discountedOffer = useMemo(() => {
        let imageDiscountedOffer = null;
        if (discountedOffers && discountedOffers.length) {
            if (discountedOffers[0] && discountedOffers[0].logo) {
                imageDiscountedOffer = discountedOffers[0].logo;
            }
        }
        if (!imageDiscountedOffer)
            return null;
        return (<Animated.View style={[styles.discountedOfferContainer, { marginRight: paddingHorizontal }, discountedOfferStyle]}>
        <Image source={{ uri: imageDiscountedOffer }} style={styles.discountedOffer}/>
      </Animated.View>);
    }, [discountedOfferStyle, discountedOffers, paddingHorizontal]);
    return (<>
      <Animated.View style={[styles.absoluteContainer, logoStyle]}>
        <Logo uri={logoUrl} onColoredBackground S64 withOutline withExtraPadding/>
      </Animated.View>
      <Animated.View style={[styles.absoluteContainer, titleStyle]}>
        <Text Text-18>{title}</Text>
        <Spacer h={4}/>
        <Text TextThin-14 Secondary>
          {subtitle}
        </Text>
        <Spacer.H16 />
        {children}
        {onPress !== undefined && (<Button hug small brandLight onPress={onPress} containerStyle={styles.button} title={buttonText || 'Go to website'}/>)}
      </Animated.View>
      {discountedOffer}
      <Animated.View style={[styles.poweredByContainer, { marginRight: paddingHorizontal }, msmStyle]}>
        <Image source={require('./img/msm.png')} style={styles.msm} resizeMode="contain"/>
      </Animated.View>
    </>);
};
const styles = StyleSheet.create({
    absoluteContainer: {
        position: 'absolute',
        left: 0,
        right: 0,
        alignItems: 'center',
        backgroundColor: 'transparent',
    },
    discountedOfferContainer: {
        position: 'absolute',
        right: rem(16),
    },
    discountedOffer: {
        height: rem(50),
        width: rem(50),
    },
    poweredByContainer: {
        position: 'absolute',
        right: rem(16),
        marginTop: -rem(40),
    },
    button: {
        paddingHorizontal: rem(50),
    },
    msm: { width: 70 },
});
export default Header;
